<div class="tw:h-full tw:flex tw:flex-col tw:flex-1 tw:items-center tw:justify-center tw:gap-3">
  <p-tag
    class="tw:rounded-full tw:w-20 tw:h-20 tw:gap-0"
    style="--p-tag-icon-size: 2rem"
    icon="pi pi-folder-open" />
  <h2 class="tw:text-3xl">"{{ item()?.name }}" belongs to a different project</h2>
  <p class="tw:text-muted-color">
    Switch to the "{{ item()?.projectSlug }}" project to view and work with this object in the
    correct context.
  </p>
  <p-button
    test-id="invalid-project-switch-project"
    [buttonProps]="{ autofocus: false }"
    label="Switch Project"
    icon="pi pi-arrow-right"
    class="tw:mt-3"
    (click)="switchToObjectProject()" />
</div>
